import { observer } from 'mobx-react-lite';
import MainView from './components/MainView';
import TrxView from './components/TrxView';
import TokenView from './components/TokenView';
import { HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import FooterBar from '@/components/navbar/FooterBar';
import SendView from './components/SendView';
import useHome from './useHome';
import SendCheckView from './components/SendCheckView';
import { truncateString } from '@/utils';
import ReceiveView from './components/ReceiveView';

const Home = observer(() => {
  const {
    activeTab,
    trxPrice,
    tokenPrice,
    selectedAsset,
    viewType,
    defaultMemo,
    activities,
    isNotActivities,
    isWritting,
    sendAddress,
    sendAsset,
    curculateKrw,
    trxAsset,
    tokenAsset,
    totalBalance,
    trxAddress,
    trxTransactions,
    tokenTransactions,
    trxBalance,
    trxKrw,
    tokenBalance,
    tokenKrw,
    isSendCheckBtnDisabled,
    isFeeNotice,
    fee,
    isSendingAsset,
    dbsBuyCount,
    dbsBuyCountKRW,
    resetSendInfo,
    onClickCopyBtn,
    onClickResetBtn,
    onClickViewType,
    onClickSendBtn,
    onClickBackBtn,
    onChangeSendAddress,
    onChangeSelectedAsset,
    onClickDeleteBtn,
    onClickResetAmountBtn,
    onPaste,
    onChangeSelectedAssetValue,
    onClickSendCheckBtn,
    onClickSendCancelBtn,
    onClickBacktoSendView,
    onClickSendCheckNextBtn,
    onMoveMainView,
    onClickCameraBtn,
    onResetSelectedAsset,
    onClickActiveTab,
    onClickPrevTransactionBtn,
    onKeyPress,
    onChangeMemo,
  } = useHome();

  return (
    <div className="wrap wrap_temporary">
      {viewType === HomeViewType.MAIN && (
        <MainView
          activeTab={activeTab}
          trxKrw={trxKrw}
          tokenKrw={tokenKrw}
          tokenBalance={tokenBalance}
          trxBalance={trxBalance}
          trxAsset={trxAsset}
          tokenAsset={tokenAsset}
          totalBalance={totalBalance}
          trxAddress={trxAddress}
          activities={activities}
          isNotActivities={isNotActivities}
          isSendingAsset={isSendingAsset}
          dbsBuyCount={dbsBuyCount}
          dbsBuyCountKRW={dbsBuyCountKRW}
          trxPrice={trxPrice}
          tokenPrice={tokenPrice}
          onClickCopyBtn={onClickCopyBtn}
          onClickResetBtn={onClickResetBtn}
          onClickViewType={onClickViewType}
          onClickSendBtn={onClickSendBtn}
          onClickActiveTab={onClickActiveTab}
          onClickPrevTransactionBtn={onClickPrevTransactionBtn}
        />
      )}
      {viewType === HomeViewType.TRX && (
        <TrxView
          trxPrice={trxPrice}
          trxTransactions={trxTransactions}
          trxBalance={trxBalance}
          trxKrw={trxKrw}
          onClickBackBtn={onClickBackBtn}
          onClickResetBtn={onClickResetBtn}
          onClickViewType={onClickViewType}
          onResetSelectedAsset={onResetSelectedAsset}
          onClickPrevTransactionBtn={onClickPrevTransactionBtn}
          onClickCopyBtn={onClickCopyBtn}
        />
      )}
      {viewType === HomeViewType.TOKEN && (
        <TokenView
          tokenTransactions={tokenTransactions}
          tokenBalance={tokenBalance}
          tokenKrw={tokenKrw}
          onClickBackBtn={onClickBackBtn}
          onClickResetBtn={onClickResetBtn}
          onClickViewType={onClickViewType}
          onResetSelectedAsset={onResetSelectedAsset}
          onClickPrevTransactionBtn={onClickPrevTransactionBtn}
          onClickCopyBtn={onClickCopyBtn}
        />
      )}
      {viewType === HomeViewType.SEND && (
        <SendView
          defaultMemo={defaultMemo}
          isSendCheckBtnDisabled={isSendCheckBtnDisabled}
          selectedAsset={selectedAsset}
          trxAsset={trxAsset}
          tokenAsset={tokenAsset}
          isWritting={isWritting}
          sendAddress={sendAddress}
          sendAsset={sendAsset}
          curculateKrw={curculateKrw}
          onKeyPress={onKeyPress}
          onChangeMemo={onChangeMemo}
          onClickSendCheckBtn={onClickSendCheckBtn}
          onClickSendCancelBtn={onClickSendCancelBtn}
          onChangeSelectedAsset={onChangeSelectedAsset}
          onClickBackBtn={onClickBackBtn}
          onChangeSendAddress={onChangeSendAddress}
          onClickDeleteBtn={onClickDeleteBtn}
          onClickResetAmountBtn={onClickResetAmountBtn}
          onPaste={onPaste}
          onChangeSelectedAssetValue={onChangeSelectedAssetValue}
          onClickCameraBtn={onClickCameraBtn}
        />
      )}
      {viewType === HomeViewType.SEND_CHECK && (
        <SendCheckView
          fee={fee}
          isFeeNotice={isFeeNotice}
          trxBalance={trxBalance}
          selectedAsset={selectedAsset}
          sendAsset={sendAsset}
          curculateKrw={curculateKrw}
          trxAddress={truncateString(trxAddress)}
          sendAddress={truncateString(sendAddress)}
          onClickBacktoSendView={onClickBacktoSendView}
          onClickSendCheckNextBtn={onClickSendCheckNextBtn}
          onClickSendCancelBtn={onClickSendCancelBtn}
        />
      )}
      {viewType === HomeViewType.RECEIVE && (
        <ReceiveView address={trxAddress} onClickCopyBtn={onClickCopyBtn} onClickBackBtn={onClickBackBtn} />
      )}
      <FooterBar
        activeTab={activeTab}
        viewType={viewType}
        onMoveMainView={onMoveMainView}
        onResetSelectedAsset={onResetSelectedAsset}
        onChangeTabType={onClickActiveTab}
        resetSendInfo={resetSendInfo}
      />
    </div>
  );
});

export default Home;
